import React from 'react';

import { Location, History } from 'history';
// @ts-ignore
import { withScope } from '@bingads-webui-react/scope-service';
import { withRouter } from 'react-router';
// @ts-ignore
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
// @ts-ignore
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
// @ts-ignore
import { withPreference } from '@bingads-webui-react/preference-context';
// @ts-ignore
import { withUserConsumer } from '@bingads-webui-react/user-context';
// @ts-ignore
import { withSettingsConsumer } from '@bingads-webui-react/settings-context';

import {
  scopeStore,
  routeStore,
  IScope,
  i18nStore,
  permissionsStore,
  serverContextStore,
  preferenceServiceStore,
  tokenStore,
  userContextStore,
  siteMapStore,
  versionStore,
  settingsContextStore,
} from './global-context-store';

interface IGlobalContextReceiverProps {
  location: Location;
  history: History;
  scope: IScope;
  i18n: any;
  permissions: any;
  serverContext: any;
  userContext: {
    CurrentCustomer: any;
    CurrentAccount: any;
    CurrentUser: any;
  };
  siteMap: any;
  preferenceService: any;
  settingsContext: any;
}

export class InternalGlobalContextReceiver extends React.PureComponent<IGlobalContextReceiverProps> {
  componentDidUpdate() {
    this.updateContextStore();
  }

  componentDidMount() {
    this.updateContextStore();
    this.initializeContextStore();
  }

  render() {
    return null;
  }

  initializeContextStore() {
    const { serverContext } = this.props;
    // version store has its own update logic
    versionStore.setState({ version: serverContext.Version, newVersion: serverContext.Version });
  }

  updateContextStore() {
    const {
      location, history, scope, i18n, permissions, serverContext, userContext, siteMap, preferenceService, settingsContext,
    } = this.props;
    scopeStore.setState({ scope });
    routeStore.setState({ history, location });
    i18nStore.setState({ i18n });
    permissionsStore.setState({ permissions });
    serverContextStore.setState({ serverContext }); // TODO: remove it if possible
    preferenceServiceStore.setState({ preferenceService });
    tokenStore.setState({ authToken: serverContext.Token });
    userContextStore.setState({ userContext });
    siteMapStore.setState({ siteMap });
    settingsContextStore.setState({ settingsContext });
  }
}

export const GlobalContextReceiver = withSettingsConsumer(withPreference(withUserConsumer(withPermissions(withI18nConsumer(withRouter(withScope(InternalGlobalContextReceiver)))))));
